import { ImportResult } from '~/domain/services/dicomProcessor';

export function markResampledResultImages(result: ImportResult): void {
    const propagatedOnto = result.structureSets[0]?.image;
    if (!propagatedOnto) {
        return;
    }
    // A later run on the same scan lands another series on the same geometry.
    const producedBy = [
        ...result.registrations,
        ...result.deformableRegistrations,
    ].map((registration) => registration.sopInstanceUid);
    for (const image of result.images) {
        if (image !== propagatedOnto) {
            image.markAsSpatiallyResampled('applied', producedBy);
        }
    }
}
